import type { PaymentMetaOptionDetails } from 'domain/payments/types';
import type { BeneficiaryField as BeneficiaryFieldType } from 'domain/payments/schemas';

export const BENEFICIARY_SOURCE = {
  erp: 'erp',
  user: 'user',
} as const;

export type BeneficiarySource = (typeof BENEFICIARY_SOURCE)[keyof typeof BENEFICIARY_SOURCE];

export interface BeneficiaryDetailsResponse {
  id: string;
  vendorId: string;
  providerName: string;
  source: BeneficiarySource;
  isDefault: boolean;
  details: PaymentMetaOptionDetails;
  vendorDisplayName: string;
}

// Field / option / visibility types are derived from the Zod schema that parses
// the form response — one declaration, no parallel type to drift. Re-exported
// here so existing local `./types` imports keep working.
export type {
  BeneficiaryField,
  BeneficiaryFieldOption,
  BeneficiaryFieldOption as SelectOption,
} from 'domain/payments/schemas';

export interface BeneficiaryFormData {
  fields: BeneficiaryFieldType[];
}

export type FormValues = Record<string, string | string[]>;

export interface BeneficiaryModalProps {
  onClose: () => void;
  onSubmit: (data: Record<string, unknown>) => Promise<unknown>;
  vendorId: string;
  vendorName: string;
  existingAccountsCount: number;
  beneficiaryId?: string;
  isEditable?: boolean;
  isDefault?: boolean;
  isExternal?: boolean;
  // Choosing a vendor's default account belongs to the beneficiaries settings
  // list, not to the payment flow (DPM-661). Defaults to true so the settings
  // call sites keep their existing behaviour untouched; the payment flow opts out.
  withDefaultToggle?: boolean;
}
